import { mapState, mapGetters } from 'vuex';

const page = {
  computed: {
    ...mapState('app', ['debugMode', 'appReady']),
    ...mapGetters('app', ['isStamp', 'isHM', 'isWeb', 'isIncein']),
    ...mapGetters('mtmUser', ['isContactless']),
    ...mapGetters('hardware', ['isIOS', 'isIOS15']),
  },
};

export default page;
